import React from 'react';

const Privacy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-header">
          <h1>Privacy Policy</h1>
          <p>Last updated: 14 April 2025</p>
        </div>

        <div className="policy-content">
          <div className="policy-section">
            <p>https://gonorwegian.site ("us", "we", or "our") operates the https://gonorwegian.site website (the "Service").</p>
            <p>This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.</p>
            <p>We will not use or share your information with anyone except as described in this Privacy Policy.</p>
            <p>We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible at https://gonorwegian.site</p>

            <h2>Information Collection And Use</h2>
            <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information ("Personal Information") may include, but is not limited to:</p>
            <ul>
              <li>Email address</li>
              <li>Username</li>
              <li>Device information</li>
            </ul>
            <p>In compliance with Norwegian data protection laws and regulations (including the Personal Data Act and GDPR as implemented in Norway), we process this information lawfully and transparently.</p>

            <h2>Legal Basis for Processing</h2>
            <p>We process your personal data based on:</p>
            <ul>
              <li>Your consent</li>
              <li>Necessity to perform our contract with you</li>
              <li>Our legitimate interests (where these do not override your rights)</li>
            </ul>
            <p>You can withdraw your consent at any time by contacting us.</p>

            <h2>Log Data</h2>
            <p>We collect information that your browser sends whenever you visit our Service ("Log Data"). This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.</p>

            <h2>Cookies</h2>
            <p>Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.</p>
            <p>We use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
            <p>We use the following types of cookies:</p>
            <ul>
              <li>Essential cookies: necessary for the website to function</li>
              <li>Preference cookies: enable the website to remember your preferences</li>
              <li>Analytics cookies: help us understand how visitors interact with our website</li>
            </ul>
            <p>You have full control over cookie settings and can manage your preferences through our cookie consent tool.</p>

            <h2>Age Restrictions</h2>
            <p><strong>IMPORTANT NOTICE:</strong> This is a social casino game that does not involve real-money gambling. Our Service is intended for users who are 18 years of age or older. We do not knowingly collect personally identifiable information from anyone under 18. If you are a parent or guardian and you are aware that your child has provided us with Personal Information, please contact us immediately.</p>
            <p>We implement age verification measures where applicable to ensure compliance with local regulations.</p>

            <h2>Service Providers</h2>
            <p>We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.</p>
            <p>These third parties have access to your Personal Information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
            <p>All service providers we use are compliant with Norwegian data protection regulations.</p>

            <h2>Security</h2>
            <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>
            <p>We implement appropriate technical and organizational measures to protect your data in accordance with Norwegian law.</p>

            <h2>Data Storage and International Transfers</h2>
            <p>Your data is primarily stored in data centers located within the European Economic Area (EEA). If we need to transfer your personal data outside the EEA, we ensure appropriate safeguards are in place as required by Norwegian law.</p>

            <h2>Your Rights</h2>
            <p>Under Norwegian data protection law, you have the following rights:</p>
            <ul>
              <li>Right to access your personal data</li>
              <li>Right to rectification of inaccurate data</li>
              <li>Right to erasure ("right to be forgotten")</li>
              <li>Right to restriction of processing</li>
              <li>Right to data portability</li>
              <li>Right to object to processing</li>
              <li>Rights relating to automated decision making and profiling</li>
            </ul>
            <p>To exercise any of these rights, please contact us using the information provided below.</p>

            <h2>Social Casino Gaming</h2>
            <p>We would like to emphasize that our platform offers social casino games that:</p>
            <ul>
              <li>Do not involve real money gambling</li>
              <li>Cannot be used to win real money or prizes with monetary value</li>
              <li>Are designed for entertainment purposes only</li>
              <li>Use virtual coins that have no real-world value</li>
            </ul>
            <p>These games simulate casino-style games but do not constitute gambling under Norwegian law.</p>

            <h2>Data Analysis</h2>
            <p>Crazy Monkey Social Casino may use your personal information for analysis purposes. This analysis includes the classification and profiling of users to facilitate more effective service delivery and personalized experiences. These analytical procedures may be automated. You have the right to object to this processing at any time by contacting us.</p>

            <h2>Changes To This Privacy Policy</h2>
            <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "last updated" date.</p>
            <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

            <h2>Supervisory Authority</h2>
            <p>If you are unsatisfied with our response to a data privacy concern, you have the right to lodge a complaint with the Norwegian Data Protection Authority (Datatilsynet).</p>

            <h2>Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at privacy@gonorwegian.site.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 